// src/components/CharacterButton/CharacterButton.js

import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import {
  CharacterButtonContainer,
  HoverMenuActivator,
  HoverMenu,
  HoverMenuButton,
  MobileButtonSpacing
} from './CharacterButtonStyles';

const CharacterButton = ({
  characterConfig,
  onAddNewResponseClick,
  onEditCharacterClick,
  onAddNewCharacter,
  onDeleteCharacter,
  isMobile }) => {
  const [activeMenu, setActiveMenu] = useState(null);

  const getInitials = (name) => {
    if (!name) return '';
    const words = name.trim().split(' ');
    return words.map((word) => word[0]).join('');
  };

  const handleConsultClick = () => {
    onAddNewResponseClick(characterConfig);
    setActiveMenu(null);
  };

  return (
    <CharacterButtonContainer
      data-testid='character-button'
      onClick={() => (!isMobile ? onAddNewResponseClick(characterConfig) : null)}
    >
      {!isMobile && <span>{characterConfig.name}</span>}

      <HoverMenuActivator
        onMouseDown={() => setActiveMenu(true)}
        onMouseEnter={() => setActiveMenu(true)}
        onMouseLeave={() => setActiveMenu(false)}
        onClick={(e) => {
          setActiveMenu(true);
          e.stopPropagation();
        }}
      >
        <MobileButtonSpacing>
          {isMobile && <span>{getInitials(characterConfig.name)}</span>}
          <FontAwesomeIcon icon={faPencilAlt} />
        </MobileButtonSpacing>
      </HoverMenuActivator>

      {activeMenu && (
        <HoverMenu
          $isActive={activeMenu}
          onMouseDown={() => setActiveMenu(true)}
          onMouseEnter={() => setActiveMenu(true)}
          onMouseLeave={() => setActiveMenu(false)}
        >
          {isMobile && <HoverMenuButton onClick={(e) => { e.stopPropagation(); handleConsultClick(); }}>Consult</HoverMenuButton>}
          <HoverMenuButton onClick={(e) => { e.stopPropagation(); onEditCharacterClick(characterConfig); }}>Edit</HoverMenuButton>
          <HoverMenuButton onClick={(e) => { e.stopPropagation(); onAddNewCharacter(characterConfig); }}>Copy</HoverMenuButton>
          <HoverMenuButton onClick={(e) => { e.stopPropagation(); onDeleteCharacter(characterConfig.name); }}>Delete</HoverMenuButton>
        </HoverMenu>
      )}
    </CharacterButtonContainer>
  );
};

export default CharacterButton;
